export interface IEventErrorResponse {
    errorCode: number;
    message: string;
    stack: string;
    trace: string;
}

export class EventErrorResponse implements IEventErrorResponse {
    public errorCode: number;
    public message: string;
    public stack: string;
    public trace: string;

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IEventErrorResponse);
    constructor(obj?: any) {
        this.errorCode = 0;
        if (obj && obj.errorCode) {
            this.errorCode = obj.errorCode;
        }
        this.message = (obj && obj.message) || '';
        this.stack = (obj && obj.stack) || '';
        if (this.stack) {
            this.stack.replace(/\n/g, '<br />&#9;');
        }
        this.trace = (obj && obj.trace) || '';
    }
}
